import { PinTheme, TypographySettings, TypographyType } from '@lessonup/pins-shared';
import { defaultPinTheme } from './defaultPinTheme';

export function getPinThemeTypography(pinTheme: PinTheme, typographyType: TypographyType): TypographySettings {
  const pinThemeTypography = pinTheme.typography[typographyType];
  const defaultPinThemeTypography = defaultPinTheme.typography[typographyType];
  return {
    fontFamily: pinThemeTypography?.fontFamily ?? defaultPinThemeTypography?.fontFamily,
    fontSize: pinThemeTypography?.fontSize ?? defaultPinThemeTypography?.fontSize,
    fontWeight: pinThemeTypography?.fontWeight ?? defaultPinThemeTypography?.fontWeight,
  };
}
